<template>
  <div class="popup" v-show="detailInfo.deviceNumber" :class="{ gray: detailInfo.deviceStatus !== '1' }">
    <div class="header">
      <p v-if="isEdit && !detailInfo.isEditPosition">
        <el-form ref="info" :model="info">
            <el-form-item prop='deviceName' required  error="请输入设备名称">
              <el-input v-model="info.deviceName" placeholder='请输入设备名称'>
              </el-input>
            </el-form-item>
          </el-form>
        </p>
      <p v-else>{{detailInfo.deviceName || '--'}}</p>
      <!-- 电磁阀-->
      <template v-if="detailInfo.deviceType === '1007'">
        <el-switch
          v-model="switchStatus"
          active-value="1"
          inactive-value="0"
          active-color="#45db5e"
          inactive-color="#999999"
          @change="updateValve">
        </el-switch>
      </template>
      <p class="state" v-else :class="detailInfo.deviceStatus === '1' ? 'normal' : 'offline' ">{{detailInfo.deviceStatus === '1' ? '在线' : '离线' }}</p>
    </div>
    <div class="content">
      <div class="item">
        <el-form v-if="isEdit" :model="bindInfo" ref="form" :rules="rules">
          <el-form-item label="设备串号" prop="deviceNumber">
            <el-select v-model="bindInfo.deviceNumber"
                      placeholder="选择绑定设备">
              <el-option
                v-for="(item, index) in deviceList"
                :label="(item.deviceName || '') + '(' + item.deviceNumber + ')'"
                :value="item.deviceNumber"
                :key="index">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <span v-else>
          设备串号：{{detailInfo.deviceNumber || '--'}}
        </span>
        <template v-if="!disabled">
          <i v-if="!isEdit && isCad" @click="onSetting" class="iconfont setting icon-shezhi1"></i>
          <i v-if="isEdit && isCad" @click="onSave" class="iconfont setting icon-baocun1"></i>
        </template>
      </div>
      <template v-if="deviceType === '1001'">
        <div class="items">
          <p class="item">所属物种：{{detailInfo.maintTypeName || '--' }}</p>
          <p class="item">地面深度：{{detailInfo.depth || '--' }}cm</p>
        </div>
        <div class='list'>
          <div v-for="(item,index) in soil" :key="index">
            <div class="icon">
              <i class="iconfont" :class="item.icon"></i>
            </div>
            <div>
              <p class="name">{{ item.name }}</p>
              <p>
                <span class="value">{{ detailInfo[item.value] }}</span>
                <span class="state" v-if="item.value !== '--'" :class="(item.status === '正常' || item.status === '--') ? 'normal' : 'alarm'">{{ item.status }}</span>
              </p>
            </div>
          </div>
        </div>
      </template>

      <template v-if="deviceType === '1015'">
        <div class='list'>
          <div v-for="(item,index) in waterquaity" :key="index">
            <div class="icon">
              <i class="iconfont" :class="item.icon"></i>
            </div>
            <div>
              <p class="name">{{ item.name }}</p>
              <p>
                <span class="value">{{ detailInfo[item.value] }}</span>
                <span
                v-if="item.icon === 'icon-rongjieyang'"
                class="state"
                :class="{
                  alarm:detailInfo.dissolvedOxygenStatus === '劣Ⅴ类',
                  normal:detailInfo.deviceStatus === '1' && detailInfo.dissolvedOxygenStatus !=='劣Ⅴ类'
                }">
                {{detailInfo.dissolvedOxygenStatus || '--'}}
              </span>
              <span
                v-if="item.icon === 'icon-andan'"
                class="state"
                :class="{ alarm:detailInfo.ammoniaNitrogenStatus === '劣Ⅴ类', normal:detailInfo.deviceStatus === '1' && detailInfo.ammoniaNitrogenStatus !=='劣Ⅴ类'
                }">
                {{detailInfo.ammoniaNitrogenStatus || '--'}}
              </span>
              </p>
            </div>
          </div>
        </div>
      </template>

      <template v-if="deviceType === '1012'">
        <div class='list'>
          <div v-for="(item,index) in weatherquailty" :key="index">
            <div class="icon">
              <i class="iconfont" :class="item.icon"></i>
            </div>
            <div>
              <p class="name">{{ item.name }}</p>
              <p class="value">{{ item.value === 'direction' ? directionTransition(detailInfo[item.value]) :
              detailInfo[item.value] }}</p>
            </div>
          </div>
        </div>
      </template>

      <template v-if="deviceType === '1004'">
        <div class="item">
          水表度数：{{detailInfo.wmLacc || '--'}}  m³
        </div>
        <div class="item">
          当日用水：{{detailInfo.wmDayLacc || '--'}}  m³
        </div>
      </template>
      <!-- 流压 -->
      <template v-if="deviceType === 'liuya'">
        <div class="item">
          流速（L/min）：{{detailInfo.flow || '--'}}
        </div>
        <div class="item">
          水压（Mpa）：{{detailInfo.pressure || '--'}}
        </div>
        <div class="item">
            水压状态：
            <span class="state" :class="(detailInfo.pressureStatus === '0' || !detailInfo.pressureStatus) ? 'normal' : 'alarm'">{{pressureStatusList[detailInfo.pressureStatus] || '--'}}</span>
        </div>
      </template>
      <template v-if="deviceType === '1014'">
        <div class="item">
          电表度数：{{detailInfo.electric || '--'}}  kW·h
        </div>
        <div class="item">
          当日用电：{{detailInfo.electricDay || '--'}}  kW·h
        </div>
        <div class='list'>
          <div v-for="(item,index) in electric" :key="index">
            <div class="icon">
              <i class="iconfont" :class="item.icon"></i>
            </div>
            <div>
              <p class="name">{{ item.name }}</p>
              <p class="value">{{ detailInfo[item.value] }}</p>
              <p class="state" v-if="item.value !== '--'" :class="(item.status === '正常' || item.status === '--') ? 'normal' : 'alarm'">{{ item.status }}</p>
            </div>
          </div>
        </div>
      </template>
      <!-- 垃圾桶 -->
      <template v-if="deviceType === '1011'">
        <div class="item">
          溢满状态：<span class="state" :class="{ alarm: detailInfo.trashcan1Status === '1', normal: detailInfo.trashcan1Status === '0' }">{{detailInfo.trashcan1Status === '0' ? '正常' : detailInfo.trashcan1Status === '1' ? '溢满' : '--'}}</span>
        </div>
      </template>

      <!-- 虫害 -->
      <template v-if="deviceType === '1017'">
        <div class="tabs">
          <div :class="{active: active === 0}" @click="setTab(0)">虫害识别</div>
          <div :class="{active: active === 1}" @click="setTab(1)">设备状态</div>
          <div :class="{active: active === 2}" @click="setTab(2)">历史趋势</div>
        </div>
        <template v-if="active === 0">
          <Carousel @imgData='imgDataChange' :width="290" :height="176" :deviceStatus="detailInfo.deviceStatus" :imgList="imgList" iconSize="24px"></Carousel>
          <el-table :header-cell-style="tableHeaderStyle" class="global-table" :data="imgData" border>
            <el-table-column label="虫害名称" width='120' show-overflow-tooltip prop="insectName"></el-table-column>
            <el-table-column label="数量" show-overflow-tooltip prop="insectNum"></el-table-column>
            <el-table-column label="图像序号" show-overflow-tooltip prop="insectType">
              <template slot-scope="scope">
                #{{scope.row.insectType}}
              </template>
            </el-table-column>
          </el-table>
        </template>
        <div class='list padding20' v-if="active === 1">
          <div v-for="(item,index) in insect" :key="index">
            <div class="icon">
              <i class="iconfont" :class="item.icon"></i>
            </div>
            <div>
              <p class="name">{{ item.name }}</p>
              <p class="value">{{ item.value || '--' }}</p>
            </div>
          </div>
        </div>
        <div v-if="active === 2">
          <el-date-picker
            :clearable = "false"
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            value-format="yyyy-MM-dd"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            class="picker">
          </el-date-picker>
          <el-table :header-cell-style="tableHeaderStyle" class="global-table" :data="history" border height="180">
            <el-table-column label="虫害名称" min-width='120' show-overflow-tooltip prop="insectName"></el-table-column>
            <el-table-column label="虫害总量" min-width='60' show-overflow-tooltip prop="insectNum"></el-table-column>
            <el-table-column label="增长率" min-width='60' show-overflow-tooltip prop="growthRate">
              <template slot-scope="scope">
                {{scope.row.growthRate}}%
              </template>
            </el-table-column>
          </el-table>
        </div>
      </template>

      <!-- 智慧监控 -->
      <template v-if="deviceType === '1002'">
        <div class="video" v-html="videoHtml">
        </div>
      </template>
    </div>
    <div v-if="!['1002', '1007'].includes(deviceType)" class="time">
      更新时间：{{detailInfo.collectTime || '--'}}
    </div>
    <!-- 电磁阀开始关闭-->
    <el-dialog
      title="选择开启时间"
      :visible.sync="showChooseDuration"
      :append-to-body="true"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="400px">
      <div class="flex">
        请选择开启时间
        <el-select
          v-model="execLength"
          filterable
          allow-create
          default-first-option
          placeholder="请选择开启时间">
          <el-option label="10分钟" value="10"></el-option>
          <el-option label="15分钟" value="15"></el-option>
          <el-option label="20分钟" value="20"></el-option>
          <el-option label="40分钟" value="40"></el-option>
        </el-select>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateValveCancel">取 消</el-button>
        <el-button type="primary" @click="updateValveCommit('1')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
 </template>

<script>
// A0/1001:土壤传感器,O0:割草机器人,E0/1007:电磁阀,L0/1015:水质监测,I0/1012:空气监测,M0/1017:虫情设备,VI/1002:视频监控,B0/1004:智能水表,C0/1014:断路器,D0:手环,F0:终端定位,H0/1011:垃圾桶,S0:工牌,V0:消防栓,W0:水压
// 1在线 2离线 3告警 X0代表X+选中图标
import Carousel from './Carousel.vue'
// import videojs from 'video.js'
import { updateAjax, deviceAjax, deviceTypeParamList } from './mapIcon'
// require('video.js/dist/video-js.css')
export const initDataList = new Map()
initDataList.set('1001', 'setSoilInfo')
initDataList.set('1002', 'playVideo')
initDataList.set('1017', 'setInsectInfo')
let oldDeviceNumber = ''
import { directionTransition } from '@/utils/formatData'
export default {
  name: 'Soil',
  components: {
    Carousel
  },
  data () {
    return {
      // 电磁阀开启关闭 - begin
      switchStatus: '0',
      showChooseDuration: false,
      execLength: '10',
      // 电磁阀开启关闭 - end
      soil: [
        {
          name: '温度(°C)',
          value: 'temperature',
          icon: 'icon-wendu',
          status: ''
        },
        {
          name: '湿度(%)',
          value: 'humidity',
          icon: 'icon-turangshidu',
          status: ''
        },
        {
          name: 'EC(mS/cm)',
          value: 'conductivity',
          icon: 'icon-EC',
          status: ''
        }
      ],
      waterquaity: [{
        icon: 'icon-shuiwei',
        name: '水位(m)',
        value: 'waterLevel'
      }, {
        icon: 'icon-shuiwen',
        name: '水温(℃)',
        value: 'temperature'
      }, {
        icon: 'icon-zhuodu',
        name: '浊度(NTU)',
        value: 'turbidity'
      }, {
        icon: 'icon-rongjieyang',
        name: '溶解氧(mg/L)',
        value: 'dissolvedOxygen'
      }, {
        icon: 'icon-andan',
        name: '氨氮(mg/L)',
        value: 'ammoniaNitrogen'
      }, {
        icon: 'icon-pH',
        name: 'pH',
        value: 'ph'
      }, {
        icon: 'icon-diandaoshuai',
        name: '电导率(μS/cm)',
        value: 'conductivity'
      }],
      weatherquailty: [{
        icon: 'icon-wendu',
        name: '温度(°C)',
        value: 'temperature'
      }, {
        icon: 'icon-wenshidu',
        name: '湿度(%)',
        value: 'humidity'
      }, {
        icon: 'icon-jiangyuliang',
        name: '降雨量(mm)',
        value: 'precipitation'
      }, {
        icon: 'icon-qiya',
        name: '气压(kPa)',
        value: 'pressure'
      }, {
        icon: 'icon-fengxiang',
        name: '风向',
        value: 'direction'
      }, {
        icon: 'icon-a-PM25',
        name: 'PM2.5(μg/m³)',
        value: 'pm25'
      }, {
        icon: 'icon-zaoyin',
        name: '噪音(db)',
        value: 'noise'
      }, {
        icon: 'icon-fengsu',
        name: '风速(m/s)',
        value: 'speed'
      }, {
        icon: 'icon-guangzhao',
        name: '光照(Lux)',
        value: 'lux'
      }, {
        icon: 'icon-co2',
        name: '二氧化碳(ppm)',
        value: 'co2'
      }, {
        icon: 'icon-fuyanglizi',
        name: '负氧离子(个/cm³)',
        value: 'negativeOxyge'
      }, {
        icon: 'icon-pm10',
        name: 'PM10(μg/m³)',
        value: 'pm10'
      }, {
        icon: 'icon-guangzhaoqiangdu',
        name: '太阳总辐射(mwh/cm²)',
        value: 'zfs'
      }],
      electric: [{
        icon: 'icon-dianya',
        name: '电压(V)',
        value: 'voltage'
      },
      {
        icon: 'icon-dianliu',
        name: '电流(A)',
        value: 'current'
      }],
      insect: [{
        icon: 'icon-gongzuozhuangtai',
        name: '工作状态',
        value: '',
        status: '1'
      }, {
        icon: 'icon-dengguan',
        name: '灯管状态',
        value: '',
        status: '1'
      }, {
        icon: 'icon-huanjingwendu',
        name: '环境温度(°C)',
        value: '',
        status: '1'
      }, {
        icon: 'icon-yukong',
        name: '雨控状态',
        value: '',
        status: '1'
      }, {
        icon: 'icon-jiarecang',
        name: '加热仓温度(°C)',
        value: '',
        status: '1'
      }, {
        icon: 'icon-wenshidu',
        name: '环境湿度(%)',
        value: '',
        status: '1'
      }, {
        icon: 'icon-guangzhao',
        name: '光控状态',
        value: '',
        status: '1'
      }, {
        icon: 'icon-wenkong',
        name: '温控状态',
        value: '',
        status: '1'
      }],
      active: 0,
      imgData: [],
      history: [],
      imgList: [],
      dateRange: [],
      videoPlay: null,
      video: require('../../assets/img/mapIcon/video.png'),
      isEdit: false,
      info: {
        deviceName: ''
      },
      bindInfo: {
        objectId: '',
        deviceNumber: '',
        projectId: ''
      },
      rules: {
        deviceNumber: [{ required: true, message: '请绑定设备', trigger: ['blur', 'change'] }]
      },
      deviceList: [],
      videoHtml: '',
      pressureStatusList: ['正常', '过低', '过高'],
      directionTransition: directionTransition
    }
  },
  props: {
    detailInfo: {
      type: Object,
      default: () => {}
    },
    showPopup: {
      type: Boolean,
      default: false
    },
    // 是否允许编辑，disabled时，不允许编辑只展示
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    deviceType () {
      return this.detailInfo.deviceType
    },
    theme () {
      return this.$store.state.theme
    },
    projectId () {
      return this.$store.state.projectId
    },
    // 是否有cad
    isCad () {
      return this.$store.getters.isCad === '1'
    }
  },
  watch: {
    detailInfo: {
      handler (val) {
        // 电磁阀状态更新变量
        this.switchStatus = this.detailInfo.switchStatus || '0'
        if (this.videoPlay) {
          this.videoPlay.dispose()
          this.videoPlay = null
          this.videoHtml = ''
        }
        const data = initDataList.get(this.deviceType)
        if (data) {
          this[data](val)
        }
        if (val.deviceType && !this.disabled) {
          this.initTime()
          this.active = 0
          this.info.deviceName = val.deviceName
          this.isEdit = false
          this.bindInfo.objectId = val.objectId
          oldDeviceNumber = val.deviceNumber
          this.bindInfo.deviceNumber = val.deviceNumber
          this.getNoBindDevice(val.deviceType)
        }
      },
      deep: true,
      immediate: true
    },
    dateRange () {
      this.getInsectData()
    }
  },
  created () {
    this.bindInfo.projectId = this.projectId
  },
  destroyed () {
    if (this.videoPlay) {
      this.videoPlay.dispose()
      this.videoPlay = null
    }
  },
  methods: {
    setSoilInfo (data) {
      this.soil[0].status = this.getTemp(data.temperatureStatus)
      this.soil[1].status = this.getHum(data.humidityStatus)
      this.soil[2].status = this.getCon(data.conductivityStatus)
    },
    setInsectInfo (data) {
      this.getImgData(data.deviceNumber)
      this.insect[0].value = this.wsTransform(data.ws)
      this.insect[1].value = this.lampTransform(data.lamp)
      this.insect[2].value = data.at
      this.insect[3].value = this.rpsTransform(data.rps)
      this.insect[4].value = data.hrt
      this.insect[5].value = data.ah
      // this.insect[4].value = data.lux
      this.insect[6].value = this.lpsTransform(data.lps)
      this.insect[7].value = this.tpsTransform(data.tps)
    },
    // 获取温度
    getTemp (temperatureStatus) {
      switch (temperatureStatus) {
        case '0':
          return '正常'
        case '1':
          return '过热'
        case '2':
          return '冰冻'
        default:
          return '--'
      }
    },
    // 获取湿度
    getHum (humidityStatus) {
      switch (humidityStatus) {
        case '0':
          return '正常'
        case '1':
          return '过涝'
        case '2':
          return '干旱'
        case '3':
          return '极度干旱'
        default:
          return '--'
      }
    },
    // 获取EC
    getCon (conductivityStatus) {
      switch (conductivityStatus) {
        case '1':
          return '正常'
        case '2':
          return '偏高'
        case '3':
          return '偏低'
        default:
          return '--'
      }
    },
    wsTransform (value) {
      return value === '0' ? '待机' : value === '1' ? '工作' : ''
    },
    lampTransform (value) {
      return value === '0' ? '灭' : value === '1' ? '亮' : ''
    },
    rpsTransform (value) {
      return value === '0' ? '正常' : value === '1' ? '雨控' : ''
    },
    lpsTransform (value) {
      return value === '0' ? '正常' : value === '1' ? '光控' : ''
    },
    tpsTransform (value) {
      return value === '0' ? '正常' : value === '1' ? '温控' : ''
    },
    imgDataChange (list) {
      this.imgData = list
    },
    setTab (tabIndex) {
      this.active = tabIndex
      this.active === 2 && this.getInsectData()
    },
    initTime () {
      const val = this.$dayjs().format('YYYY-MM-DD')
      const vals = this.$dayjs().subtract(7, 'day').format('YYYY-MM-DD')
      this.dateRange = [vals, val]
    },
    // 获取虫害轮播图
    getImgData (deviceNumber) {
      this.$axios.get(this.$apis.device.selectInsectImgByPage, {
        deviceNumber: deviceNumber
      }).then((res) => {
        this.imgList = res.list || []
      })
    },
    // 查询虫情历史趋势
    getInsectData () {
      this.$axios.get(this.$apis.device.selectInsectImgByList, {
        deviceNumber: this.detailInfo.deviceNumber,
        startDate: this.dateRange[0],
        endDate: this.dateRange[1]
      }).then((res) => {
        this.history = res || []
      })
    },
    tableHeaderStyle () {
      return 'background-color:#F4F7FA;color: #484A59;font-family: PingFang SC;font-weight: 400;'
    },
    // 视频播放
    async playVideo () {
      const info = await this.$axios.get(this.$apis.device.selectCameraDemourl)
      this.videoHtml =
        `<video
          id="videoPlay"
          ref="videoPlayer"
          class="video-js vjs-default-skin vjs-big-play-centered"
          controls
          autoplay
          muted
          preload="auto"
          poster='${this.video}'
          style="width: 100%;height: 100%;"
        >
        <source src="${info.addressLive}" type="application/x-mpegURL" />
      </video>`
      const options = {
        bigPlayButton: false,
        textTrackDisplay: false,
        posterImage: true,
        errorDisplay: false,
        controlBar: true
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.videoPlay = videojs('videoPlay', options)
          // this.videoPlay.play()
        }, 1000)
      })
    },
    onSetting () {
      this.isEdit = true
    },
    onSave () {
      if (this.bindInfo.deviceNumber !== oldDeviceNumber) {
        this.onSubmit()
      } else {
        this.updateDeviceName()
      }
    },
    updateDeviceName () {
      this.$refs.info.validate((valid) => {
        if (valid) {
          this.$axios.post(updateAjax.get(this.deviceType), {
            deviceNumber: this.detailInfo.deviceNumber,
            longitude: this.detailInfo.longitude,
            deviceName: this.info.deviceName,
            latitude: this.detailInfo.latitude
          }).then(() => {
            this.$message.success('保存成功')
            this.$emit('fresh')
            // this.detailInfo.deviceName = this.info.deviceName
            this.isEdit = false
          })
        }
      })
    },
    // 查询未绑定的设备
    getNoBindDevice (deviceType) {
      this.$axios.get(deviceAjax.get(deviceType), {
        isCad: '0',
        isDeviceCad: '0',
        projectId: this.projectId
      }).then(res => {
        this.deviceList = [{ deviceName: this.detailInfo.deviceName, deviceNumber: this.detailInfo.deviceNumber }]
        this.deviceList = this.deviceList.concat(deviceTypeParamList.get(deviceType) ? res[deviceTypeParamList.get(deviceType)].list : res.list || [])
      })
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$axios.post(this.$apis.device.updateJgCad, this.bindInfo).then(res => {
            this.$message.success('绑定成功')
            this.isEdit = false
            this.$emit('fresh')
          })
        }
      })
    },
    // 更新电磁阀状态
    updateValve () {
      this.$confirm(`是否确认${this.switchStatus === '1' ? '开启' : '关闭'}该电磁阀？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.switchStatus === '1') {
          this.showChooseDuration = true
        } else {
          this.updateValveCommit('0')
        }
      }).catch(() => {
        this.switchStatus = this.switchStatus === '1' ? '0' : '1'
      })
    },
    updateValveCancel () {
      this.showChooseDuration = false
      this.switchStatus = '0'
    },
    updateValveCommit (command) {
      this.showChooseDuration = false
      const execObj = command === '1' ? { execLength: this.execLength } : {}
      this.$axios.post(this.$apis.irrigation.insertJgIrrigationValveRecord, {
        deviceNumber: this.detailInfo.deviceNumber,
        ...execObj,
        command
      }).then(() => {
        this.$message.success('操作成功')
        this.$emit('updateValveStatus', { ...this.detailInfo, switchStatus: this.switchStatus })
      })
    }
  }
}
</script>

 <style scoped lang='scss'>
 .popup{
  &.gray{
  .icon{
    background: #B7B7B7 !important;
    border: 2px solid #B7B7B7 !important;
  }
  .setting{
    color: #B7B7B7 !important;
  }
}
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 34px;
    background: #2E3C55;
    border-radius: 10px 10px 0px 0px;
    padding: 10px 19px;
    color: #FFFFFF;
    p:nth-of-type(1){
      width: 300px;
      text-overflow: ellipsis;
      white-space: nowrap;
      overflow: hidden;
    }
  }
  .state{
    margin-left: 2px;
    // color: #03FF21;
    &.offline{
      color: #E6E6E6;
      //
    }
    &.alarm{
      //
      color: #E51212;
    }
    &.normal{
      //
      color: #03FF21;
    }
  }
  .content{
    color: var(--header-bar-title-color);
    // background: var(--right-bg-color);
    margin: 20px 20px -8px 20px;
    padding-bottom: 20px;
    font-size: 12px;
    .video {
      width: 360px;
      height: 180px;
      border-radius: 4px;
      margin-top: -16px;
    }
    .item{
      position: relative;
      padding-left: 13px;
      margin-bottom: 19px;
      .setting{
        position: absolute;
        right: 0;
        top: 3px;
        cursor: pointer;
        color: #42A5F5;
      }
      &::after{
        position: absolute;
        content: '';
        left: 0px;
        top: calc(50% - 2px);
        width: 4px;
        height: 4px;
        background: var(--header-bar-title-color);
        border-radius: 2px;
      }
    }
    .list{
      // display: flex;
      // flex-wrap: wrap;
      display: grid;
      grid-template-columns: 130px 120px 121px;
      &.padding20{
        margin-top: 21px;
      }
      >div{
        display: flex;
        flex: 0 0 calc((100%)/3);
        font-size: 12px;
        margin-bottom: 28px;
        .icon{
          display: flex;
          justify-content: center;
          align-items: center;
          flex-shrink: 0;
          width: 30px;
          height: 30px;
          background: #42A5F5;
          border-radius: 50%;
          border: 2px solid #D8EEFF;
          margin-right: 9px;
          i {
            color: #ffffff;
          }
        }
        .status {
          &.alarm{
            color: #FF3F29;
          }
          &.normal{
            color: #52C41A;
          }
        }
        &:last-child, &:nth-of-type(12), &:nth-of-type(11){
          .name{
            white-space: nowrap;
          }
        }
        &:nth-of-type(12){
          grid-column: 1 / 2;
        }
      }
    }
  }
  .time{
    height: 30px;
    line-height: 30px;
    background: #EAEEF5;
    border-radius: 0px 0px 10px 10px;
    text-align: center;
    font-size: 12px;
  }

  .tabs{
    display: flex;
    width: 360px;
    height: 27px;
    background: #3277F3;
    font-family: PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #FFFFFF;
    overflow: hidden;
    padding-left: 6px;
    padding-top: 2px;
    >div{
      display: flex;
      justify-content: center;
      align-content: center;
      width: 66px;
      cursor: pointer;
      line-height: 24px;
      &.active{
        width: 66px;
        // height: 26px;
        // background: #F5F5F5;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 12px;
        color: #000000;
        border-bottom: 66px solid #F5F5F5;
        border-right: 10px solid transparent;
      }
    }
  }
  ::v-deep {
    .el-date-editor{
      width: 294px;
      height: 30px;
      background: #FFFFFF;
      border-radius: 10px;
      border: 1px solid #C3C3C3;
      margin: 20px 33px;
    }
    .el-table th.gutter{
      display: none;
      width:0
    }
    .el-table colgroup col[name='gutter']{
      display: none;
      width: 0;
    }
  }
 }
 ::v-deep .el-form-item{
  margin-bottom: 0 !important;
 }
</style>
